import {Box, Grid, Typography} from '@mui/material';
import {IMainGetCategoriesResponse} from '../../models/store.model';
import './storeCategory.css';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {setHeaderTitle} from '../../redux/headerTitle/headerTitleSlice';
import StorefrontIcon from '@mui/icons-material/Storefront';
import {SmartImage} from '../../components/images/SmartImage';

interface StoresCategoryProps {
    subCategories: IMainGetCategoriesResponse[];
    onClick: (id: number) => void;
}

const StoresCategory = ({subCategories, onClick}: StoresCategoryProps) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            setHeaderTitle({
                header: 'بازار',
                color: 'var(--header-color)',
                parentRoute: null,
            })
        );
    }, []);
    return (
        <div className="place-content-center px-5 py-3">
            <Grid container sx={{overflowX: 'auto'}}>
                {subCategories.map((good, index) => (
                    <Grid
                        key={index}
                        container
                        xs={4}
                        sm={3}
                        lg={3}
                        xl={3}
                        flexDirection={'row'}
                        sx={{
                            marginBottom: '15px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '5px',
                            height: '100%',
                        }}
                        onClick={() => {
                            onClick(good.id);
                        }}
                    >
                        <Grid
                            item
                            className=""
                            sx={{
                                backgroundColor: `${good.colorCode}`,
                                borderRadius: '25px',
                                padding: '7px !important',
                            }}
                        >
                            {good.logoUrl ? (
                                <SmartImage
                                    src={`${good.logoUrl}`}
                                    alt={good.title}
                                    imageStyle={{
                                        objectFit: 'contain',
                                        width: '70px',
                                        height: '70px',
                                        minHeight: '70px',
                                        maxHeight: '70px',
                                        maxWidth: '70px',
                                        minWidth: '70px',
                                        justifySelf: 'center',
                                        padding: '5px !important',
                                    }}
                                    size={70}
                                    borderRadius={25}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <StorefrontIcon
                                        sx={{
                                            color: '#D7DBEC',
                                            fontSize: '50px',
                                        }}
                                    />
                                </Box>
                            )}
                        </Grid>
                        <Grid item sx={{width: '100%', height: '20%'}}>
                            <Typography
                                sx={{
                                    color: 'var(--primary-text-color)',
                                    fontSize: '0.8rem',
                                    textAlign: 'center',
                                }}
                            >
                                {good.title}
                            </Typography>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default StoresCategory;
